/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="16" cy="16" r="16" _fill="#F7F7F9"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M23.86 12.07H8.14v-1.684h15.72v1.684zM23.86 17.123H8.14v-1.684h15.72v1.684zM23.86 22.175H8.14v-1.684h15.72v1.684z" _fill="#0B2C62"/>'
  }
})
